import { Box, Icon, IconButton, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigationState } from '@react-navigation/native'
import React, { useCallback, useEffect, useRef } from 'react'
import { FlatList } from 'react-native'
import List from '../../comps/List'
import { ListItemType, ListTypes } from '../../comps/ListItem'
import { NavItems } from '../../comps/NavItems'
import { sideMenuBottomData } from '../../data/static/data'
import { loginStrings, staticStrings } from '../../data/static/strings'
import { APIEndPoints } from '../../network/APIEndpoints'
import { navigationRef } from '../RootNav'
import { Routes } from '../routes'
import { defaultSideMenuData, defaultSuperMerchantSideMenuData } from './NavBar'
import styles from './styles'

interface NavBarProps {
  onPress: any
  notAllowedPermissions?: Array<String>
  isSuperMerchant?: boolean
  showPayouts?: boolean
  supersetDashboards?: any
  hasSupersetPermission?: boolean
  shouldEnableSettingForSuperset?: boolean
}
const { REACT_APP_ENDPOINT = '' } = window?._env_ ?? {}
export const NavBarNew = ({
  onPress,
  notAllowedPermissions,
  isSuperMerchant,
  showPayouts,
  supersetDashboards,
  hasSupersetPermission,
  shouldEnableSettingForSuperset,
}: NavBarProps) => {
  const [sideMenuItems, setSideMenuItems] = React.useState([])
  const navigation: any = navigationRef

  const [scrollInfo, setScrollInfo] = React.useState({ displayHeight: 0, virtualHeight: 0, contentOffset: 0 })
  const flatListRef = useRef(null)
  const delayRef = useRef(null)

  const updateSelected = () => {
    const SIDE_MENU_ITEMS = getSideMenuItems(
      isSuperMerchant,
      notAllowedPermissions,
      showPayouts,
      supersetDashboards,
      hasSupersetPermission,
      shouldEnableSettingForSuperset,
    )
    let pathName = window.location.pathname.slice(1)
    let queryParams = window.location.search
    if (REACT_APP_ENDPOINT && pathName.startsWith(REACT_APP_ENDPOINT.slice(1))) {
      pathName = pathName.slice(REACT_APP_ENDPOINT.length)
    }
    if (!pathName) {
      pathName = SIDE_MENU_ITEMS?.[0]?.path
    }

    setSideMenuItems(
      SIDE_MENU_ITEMS.map((item) => ({
        ...item,
        isSelected: item?.path === pathName || item?.subMenu?.some((subMenuItem) => subMenuItem?.path === pathName),
        subMenu: item?.subMenu?.map((subMenuItem, index) => {
          return {
            ...subMenuItem,
            isSelected: subMenuItem?.path === pathName + queryParams,
          }
        }),
      })),
    )
  }

  const routeName = useNavigationState((state) => {
    // const route = state.routes[state.index]
    console.log('state', state)
    return state.routes
  })
  useEffect(() => {
    clearTimeout(delayRef.current)
    delayRef.current = setTimeout(() => {
      updateSelected()
    }, 300)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isSuperMerchant,
    notAllowedPermissions,
    showPayouts,
    supersetDashboards,
    hasSupersetPermission,
    shouldEnableSettingForSuperset,
    routeName,
  ])

  const onNavItemPress = useCallback(
    (clickedItem) => {
      !clickedItem?.isDivider &&
        setSideMenuItems(
          sideMenuItems.map((item) => ({
            ...item,
            isSelected: item?.id === clickedItem?.id,
            subMenu: item?.subMenu?.map((subMenuItem, index) => ({ ...subMenuItem, isSelected: index === 0 })),
          })),
        )

      navigation.navigate(clickedItem?.navigateTo, clickedItem?.subMenu?.[0]?.queryParams)
    },
    [navigation, sideMenuItems],
  )
  const onSubMenuItemPress = useCallback(
    (clickedItem, clickedSubMenuItem) => {
      setSideMenuItems(
        sideMenuItems.map((item) => ({
          ...item,
          isSelected: item?.id === clickedItem?.id,
          subMenu: item?.subMenu?.map((subMenuItem) => ({
            ...subMenuItem,
            isSelected: subMenuItem.id === clickedSubMenuItem.id,
          })),
        })),
      )
      navigation.navigate(clickedSubMenuItem?.navigateTo, clickedSubMenuItem?.queryParams)
    },
    [navigation, sideMenuItems],
  )

  const onFooterItemPress = (item) => {
    if (!item?.isDivider) {
      if (item?.navigateTo === Routes.FAQS) {
        window.open(APIEndPoints.faqs, staticStrings.targetBlank)
      } else {
        setSideMenuItems(
          sideMenuItems.map((item) => ({
            ...item,
            isSelected: false,
            subMenu: item?.subMenu?.map((subMenuItem) => ({
              ...subMenuItem,
              isSelected: false,
            })),
          })),
        )

        navigation?.navigate(item?.navigateTo)
      }
    }
  }

  const renderNavBarItem = ({ item, index }) => {
    return (
      <NavItems
        type={ListTypes.SIDE_MENU}
        data={item}
        index={index}
        onPress={onNavItemPress as any}
        onSubMenuItemPress={onSubMenuItemPress}
      />
    )
  }

  return (
    <Box {...styles.menuFooterCOntainer} height={'100%'}>
      <Box flex={1}>
        <FlatList
          ref={flatListRef}
          ListHeaderComponent={Logo}
          data={sideMenuItems}
          renderItem={renderNavBarItem}
          showsVerticalScrollIndicator={false}
          onLayout={({
            nativeEvent: {
              layout: { height },
            },
          }: any) => {
            setScrollInfo({ ...scrollInfo, displayHeight: height })
          }}
          onScroll={({
            nativeEvent: {
              contentOffset: { y },
            },
          }: any) => {
            setScrollInfo({ ...scrollInfo, contentOffset: y })
          }}
          onContentSizeChange={(_, virtualHeight) => {
            setScrollInfo({ ...scrollInfo, virtualHeight })
          }}
        />
        <ModBox
          alignItems={'center'}
          show={scrollInfo.virtualHeight - scrollInfo.displayHeight > 50}
          marginTop={20}
          borderColor={'WHITE'}
          opacity={scrollInfo.virtualHeight === scrollInfo.displayHeight + scrollInfo.contentOffset ? 0.3 : 1}
          borderTopWidth={1}>
          <IconButton
            size={32}
            color="WHITE"
            id={'ARROW_DOWN'}
            testID={'expand-bottom-nav'}
            onPress={() => {
              flatListRef?.current?.scrollToOffset({ offset: scrollInfo.contentOffset + 30 })
            }}
          />
        </ModBox>
      </Box>
      <Box {...styles.menuFooterCOntainer}>
        <List type={ListItemType.MENU_TITLE} data={sideMenuBottomData} onPress={onFooterItemPress} />
      </Box>
    </Box>
  )
}

const getSideMenuItems = (
  isSuperMerchant,
  notAllowedPermissions,
  showPayouts,
  supersetDashboards,
  hasSupersetPermission,
  shouldEnableSettingForSuperset,
) => {
  const navItems = isSuperMerchant ? defaultSuperMerchantSideMenuData : defaultSideMenuData
  const supersetDashboardItem = getSuperSetDashboardItem(supersetDashboards)
  return (
    hasSupersetPermission
      ? [...supersetDashboardItem, ...(shouldEnableSettingForSuperset ? [defaultSideMenuData?.[14]] : [])]
      : navItems
  )
    ?.filter((item) => !notAllowedPermissions?.includes(item?.value))
    ?.filter((item: any) => showPayouts || item?.value !== 'Payouts')
}

const getSuperSetDashboardItem = (supersetDashboards: any) => {
  return supersetDashboards?.length > 0
    ? [
        {
          id: '35',
          value: 'Analytics',
          iconId: 'TRANSACTIONS',
          hasSubMenu: true,
          path: Routes.SUPERSET_DASHBOARD,
          navigateTo: Routes.SUPERSET_DASHBOARD,
          subMenu: supersetDashboards.map((item, index) => ({
            id: index + 1 + '',
            value: item?.name,
            queryParams: { dashboardId: item.dashboardId },
            path: Routes.SUPERSET_DASHBOARD + '?dashboardId=' + item.dashboardId,
            navigateTo: Routes.SUPERSET_DASHBOARD,
          })),
        },
      ]
    : []
}
const Logo = () => {
  return (
    <Box {...styles.logo}>
      <Icon id={'JIO_ICON'} color={'WHITE'} size={32} />
      <Spacer size={5} direction="horizontal" />
      <Text type={'largeTitle'} {...styles.logoText}>
        {loginStrings.pay}
      </Text>
    </Box>
  )
}

const getUrlHref = () => {
  const pathName = window?.location?.pathname?.slice(1)
  const queryParms: any = getQueryParms(window?.location?.search)
  return pathName + (queryParms?.path ?? '')
}

const getQueryParms = (queryString) => {
  const params = new URLSearchParams(queryString)
  const queryParams = {}
  params.forEach((value, key) => {
    queryParams[key] = value
  })
  return queryParams
}
